import type { ComponentProps } from 'react';
import { Text } from '@savvy-kit/foundations/text';
import { isNil } from 'es-toolkit';
import numeral from 'numeral';

import { errorColors, secondaryColors, textColors } from '@savvy/deprecated-shared/theme';

type GetPerformanceColorParams = {
  readonly negativeColor?: string;
  readonly performance?: number | null;
  readonly positiveColor?: string;
};
export function getPerformanceColor({ negativeColor, performance, positiveColor }: GetPerformanceColorParams) {
  if (isNil(performance) || performance === 0) {
    return textColors.secondary;
  } else if (performance > 0) {
    return positiveColor ?? secondaryColors.main;
  }
  return negativeColor ?? errorColors.main;
}

export const getPerformanceArrow = (performanceValue?: number) => {
  if (!performanceValue || performanceValue === 0) {
    return '';
  } else if (performanceValue > 0) {
    return '↗';
  }
  return '↘';
};

export const getPercentPerformanceText = (performancePercentage: number) => {
  return getPerformanceArrow(performancePercentage) + numeral(Math.abs(performancePercentage)).format('0.00%');
};

type ColorCodedPerformanceTypographyParams = GetPerformanceColorParams & ComponentProps<typeof Text>;
function ColorCodedPerformanceTypography({
  performance,
  negativeColor,
  positiveColor,
  variant = 'body-sm',
  ...otherTextProps
}: ColorCodedPerformanceTypographyParams) {
  if (!performance) {
    return null;
  }
  return (
    <Text
      style={{ color: getPerformanceColor({ negativeColor, performance, positiveColor }) }}
      variant={variant}
      {...otherTextProps}
    >
      {getPercentPerformanceText(performance)}
    </Text>
  );
}
export default ColorCodedPerformanceTypography;
